import { render } from "./PageScrollTopBtn.vue?vue&type=template&id=76a8f2b1"
import script from "./PageScrollTopBtn.vue?vue&type=script&lang=js"
export * from "./PageScrollTopBtn.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__